import React from 'react';
import { useMediaQuery } from 'react-responsive';
import AboutContent from './AboutContent';

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  return isMobile ? children : null;
};

const MobileResponsive = ({ history }) => (
  <Mobile>
    <AboutContent history={history} />
  </Mobile>
);

export default MobileResponsive;
